<div class="email-logs">
  <div class="email-logs__filters">
    @if (!isPerUserMode) {
      <mat-form-field appearance="outline">
        <mat-label>Recipient email</mat-label>
        <input
          matInput
          data-testid="email-logs-search"
          [value]="filterEmail"
          (input)="onEmailFilterChange($any($event.target).value)"
          placeholder="Filter by recipient"
        />
      </mat-form-field>
    }

    <mat-chip-listbox multiple class="email-logs__type-chips" (change)="onTypesChanged($event.value)">
      @for (type of eventTypes; track type) {
        <mat-chip-option [value]="type" [selected]="selectedTypes.includes(type)">{{ type }}</mat-chip-option>
      }
    </mat-chip-listbox>
  </div>

  @if (loading) {
    <div class="email-logs__loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <table mat-table [dataSource]="events" class="email-logs__table">
    <ng-container matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef>Time</th>
      <td mat-cell *matCellDef="let row">{{ row.timestamp }}</td>
    </ng-container>

    <ng-container matColumnDef="eventType">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let row" [attr.data-event-type]="row.eventType">{{ row.eventType }}</td>
    </ng-container>

    <ng-container matColumnDef="recipientEmail">
      <th mat-header-cell *matHeaderCellDef>Recipient</th>
      <td mat-cell *matCellDef="let row">{{ row.recipientEmail }}</td>
    </ng-container>

    <ng-container matColumnDef="subType">
      <th mat-header-cell *matHeaderCellDef>Detail</th>
      <td mat-cell *matCellDef="let row">{{ row.subType }}</td>
    </ng-container>

    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef>From</th>
      <td mat-cell *matCellDef="let row">{{ row.source }}</td>
    </ng-container>

    <ng-container matColumnDef="configSet">
      <th mat-header-cell *matHeaderCellDef>Config set</th>
      <td mat-cell *matCellDef="let row">{{ row.configSet }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="rowClass(row)"></tr>
  </table>

  @if (!loading && events.length === 0) {
    <div class="email-logs__empty">No email events found.</div>
  }

  <mat-paginator
    [length]="total"
    [pageIndex]="pageNumber - 1"
    [pageSize]="pageSize"
    [pageSizeOptions]="[25, 50, 100]"
    (page)="onPageChange($event)"
  ></mat-paginator>
</div>
